import { type AxiosRequestConfig, httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export interface SetTagsParams {
  order_id: string;
  tags: string[];
}

export const setTagsFn = async (
  params: SetTagsParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.get<NonNullable<unknown>>(
    apiRoutes.order.setTags,
    { params, ...config }
  );
  return response.data;
};
